import { useQuery } from "@tanstack/react-query";
import { ShipProcessingFeeListSchema, type ShipProcessingFee } from "@/schemas/ship";

type ChannelProcessingFeeSortedResponse = {
  airFees: ShipProcessingFee[];
  seaFees: ShipProcessingFee[];
};

const parseProcessingFeesResponse = (payload: unknown): ChannelProcessingFeeSortedResponse => {
  const response = payload as { data?: unknown };

  if (!response.data || typeof response.data !== "object") {
    throw new Error("Invalid processing fees response");
  }

  const { airFees, seaFees } = response.data as {
    airFees?: unknown;
    seaFees?: unknown;
  };

  return {
    airFees: ShipProcessingFeeListSchema.parse(airFees),
    seaFees: ShipProcessingFeeListSchema.parse(seaFees),
  };
};

async function fetchSortedProcessingFees() {
  const response = await fetch("/api/processing-fees");

  if (!response.ok) {
    throw new Error(`Failed to fetch processing fees (${response.status})`);
  }

  return parseProcessingFeesResponse(await response.json());
}

export const useChannelProcessingFeesSorted = () => {
  return useQuery({
    queryKey: ["ship", "processingfee"],
    queryFn: fetchSortedProcessingFees,
    refetchOnWindowFocus: false,
  });
};
